import React from 'react';
import Card from './Card';

const CardGrid = ({ cards }) => {
  return (
    <div className="card-grid">
      {cards.map((card, index) => (
        <Card
          key={index}
          image={card.image}
          title={card.title}
          skills={card.skills}
          description={card.description}
        />
      ))}
    </div>
  );
};

export default CardGrid;